import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@strava/ui/Avatar';
import clsx from '@strava/ui/clsx';
import { isMobile } from 'utils/general-utils';
import { useFriendsContext } from '../../../state/FriendsContext';
import { INVITE_FRIENDS } from '../../../utils/friendsConstants';

import styles from './AthleteInfo.scss';

const AthleteInfo = ({ friend, children }) => {
  const { state } = useFriendsContext();
  return (
    <li className={styles.listRow}>
      <div
        className={clsx(
          styles.athleteMetadata,
          state.source !== INVITE_FRIENDS &&
            !friend.isFollowable &&
            styles.grayedOut
        )}
        data-cy="athlete-metadata"
      >
        <Avatar
          src={friend.picture || ''}
          title={friend.displayName}
          alt=""
          type="athlete"
          badge={friend.badge}
          size={isMobile() ? 'small' : 'default'}
          style={{ flexShrink: 0 }}
        />
        <div className={styles.nameAndSubtitle}>
          <h4>{friend.displayName}</h4>
          <p>{friend.subtitle}</p>
        </div>
      </div>
      {children}
    </li>
  );
};

AthleteInfo.propTypes = {
  friend: PropTypes.shape({
    isFollowable: PropTypes.bool,
    picture: PropTypes.string,
    badge: PropTypes.string,
    displayName: PropTypes.string,
    subtitle: PropTypes.string
  }).isRequired,
  children: PropTypes.node.isRequired
};

export default AthleteInfo;
